export default __webpack_public_path__ + "static/media/project2-mac.c63a0e6b.png";